import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useSetAtom } from 'jotai';
import React from 'react';
import styled from 'styled-components/native';
import MapIcon from '@/assets/icon/ic_map_detailed.svg';
import SearchIcon from '@/assets/icon/ic_search_detailed.svg';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import useNavigation from '@/navigation/useNavigation';
import { searchModeAtom } from '@/screens/SearchScreen/atoms';
export default function SearchButtonSection() {
    const navigation = useNavigation();
    const setSearchMode = useSetAtom(searchModeAtom);
    const goToSearch = () => {
        setSearchMode('place');
        navigation.navigate('Search', { initKeyword: '', toMap: false });
    };
    const goToMap = () => {
        setSearchMode('place');
        navigation.navigate('Search', { initKeyword: '', toMap: true });
    };
    return (_jsx(LogParamsProvider, { params: { displaySectionName: 'search_button_section' }, children: _jsx(Container, { children: _jsxs(SearchBar, { children: [_jsxs(LeftSection, { children: [_jsx(SccPressable, { elementName: "home_v2_map_button", onPress: goToMap, children: _jsx(MapIcon, { width: 24, height: 24, color: color.gray80v2 }) }), _jsx(TextPressable, { elementName: "home_v2_search_button", onPress: goToSearch, children: _jsx(SearchButtonText, { children: "\uD06C\uB7EC\uC154\uB2D8, \uC624\uB298\uC740 \uC5B4\uB514\uB85C \uAC08\uAE4C\uC694?" }) })] }), _jsx(SccPressable, { elementName: "home_v2_search_icon_button", onPress: goToSearch, children: _jsx(SearchIcon, { width: 24, height: 24, color: color.gray40v2 }) })] }) }) }));
}
const Container = styled.View `
  padding-horizontal: 20px;
  margin-bottom: 16px;
`;
const SearchBar = styled.View `
  flex-direction: row;
  align-items: center;
  height: 44px;
  background-color: ${color.white};
  border-radius: 8px;
  padding-horizontal: 12px;
  gap: 16px;
  shadow-color: #000;
  shadow-offset: 0px 0px;
  shadow-opacity: 0.15;
  shadow-radius: 4px;
  elevation: 2;
`;
const LeftSection = styled.View `
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const TextPressable = styled(SccPressable) `
  flex: 1;
`;
const SearchButtonText = styled.Text `
  color: ${color.gray40v2};
  font-size: 16px;
  line-height: 24px;
  font-family: ${font.pretendardRegular};
  letter-spacing: -0.32px;
`;
